<div *ngIf="i18nTraslation" class="main-translation">
  <p class="label-main-translation">{{ 'createtourdetails.Traducción principal: ' | translate }} </p>
  <div>{{ text | mainTranslationEscaped : showFullText : mainTranslationLimit }}</div>
  <label (click)="onToggleReadMore()" *ngIf="!showFullText && showReadMore" class="more-info">{{ 'createtourdetails.Leer más' | translate }}</label>
  <label (click)="onToggleReadMore()" *ngIf="showFullText && showReadMore" class="more-info">{{ 'createtourdetails.Leer menos' | translate }}</label>
</div>